import type { ResourceStatus } from '../types';

export class ListParams {
    page?: number;
    size?: number;
    sort?: string;

    first?: number;
    rows?: number;
    sortField?: string;
    sortOrder?: 1 | -1;

    search?: string;
    status?: ResourceStatus;

    constructor(partial: Partial<ListParams> = {}) {
        this.page = partial.page;
        this.size = partial.size;
        this.sort = partial.sort;

        this.first = partial.first;
        this.rows = partial.rows;
        this.sortField = partial.sortField;
        this.sortOrder = partial.sortOrder;

        this.search = partial.search;
        this.status = partial.status;
    }
}